export default "__VITE_ASSET__CSdXdKIM__"